import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  type: "",
  currentStepIndex: 0,
  currentSubstepIndex: 0,
};

const travelInsuranceChangePlanFlowSlice = createSlice({
  name: "travelInsuranceChangePlanFlow",
  initialState,
  reducers: {
    setChangePlanFlowType: (state, action) => {
      state.type = action.payload.type;
      state.currentStepIndex = action.payload.currentStepIndex || 0;
      state.currentSubstepIndex = action.payload.currentSubstepIndex || 0;
    },
    setCurrentStepIndex: (state, action) => {
      state.currentStepIndex = action.payload;
    },
    setCurrentSubstepIndex: (state, action) => {
      state.currentSubstepIndex = action.payload;
    },
    resetChangePlanFlow: (state) => {
      state.type = "";
      state.currentStepIndex = 0;
      state.currentSubstepIndex = 0;
    },
  },
});

export const {
  setChangePlanFlowType,
  setCurrentStepIndex,
  setCurrentSubstepIndex,
  resetChangePlanFlow,
} = travelInsuranceChangePlanFlowSlice.actions;

export const selectChangePlanFlowType = (state) =>
  state.travelInsuranceChangePlanFlow.type;
export const selectCurrentStepIndex = (state) =>
  state.travelInsuranceChangePlanFlow.currentStepIndex;
export const selectCurrentSubstepIndex = (state) =>
  state.travelInsuranceChangePlanFlow.currentSubstepIndex;

export default travelInsuranceChangePlanFlowSlice.reducer;